const e = {
  color: {
    default: "#405261ff"
  }
};
export {
  e as helpText
};
